import type { TrigKey } from './keys';

export const pa: Partial<Record<TrigKey, string>> = {
  'app.eyebrow': 'ਗਣਿਤ · ਤ੍ਰਿਕੋਣਮਿਤੀ',
  'panel.experiment': 'ਪ੍ਰਯੋਗ',
  'panel.params': 'ਪੈਰਾਮੀਟਰ',
  'panel.scene': 'ਪ੍ਰਯੋਗ ਚੁਣੋ',
  'experiment.right-triangle.label': 'ਸਮਕੋਣ ਤ੍ਰਿਕੋਣ',
  'experiment.unit-circle.label': 'ਇਕਾਈ ਚੱਕਰ',
  'experiment.wave-studio.label': 'ਤਰੰਗ ਸਟੂਡੀਓ',
  'experiment.identity-playground.label': 'ਸਮਾਨਤਾਵਾਂ',
  'experiment.triangle-solver.label': 'ਤ੍ਰਿਕੋਣ ਹੱਲਕਾਰ',
  'experiment.circular-polar.label': 'ਚੱਕਰ ਅਤੇ ਧਰੁਵ',
  'hint.line1': 'ਬਿੰਦੂ ਖਿੱਚੋ ਅਤੇ ਸਲਾਈਡਰ ਚਲਾਓ।',
  'hint.line2': 'ਸਿੱਖਿਆਤਮਕ ਸਮੱਗਰੀ ਰੇਖਾਗਣਿਤ ਵਿੱਚ ਹੈ, ਪਾਠ ਵਿੱਚ ਨਹੀਂ।',
  'rt.angle.a': 'ਕੋਣ A',
  'rt.angle.b': 'ਕੋਣ B',
  'rt.angle.value': '∠',
  'rt.units.rad': 'ਰੇਡੀਅਨ',
  'rt.show.sin': 'sin',
  'rt.show.cos': 'cos',
  'rt.show.tan': 'tan',
  'rt.snap': '30°/45°/60° ਤੇ ਸਨੈਪ',
  'uc.units': 'ਇਕਾਈਆਂ',
  'uc.show.sin': 'sin',
  'uc.show.cos': 'cos',
  'uc.show.tan': 'tan',
  'uc.show.csc': 'csc',
  'uc.show.sec': 'sec',
  'uc.show.cot': 'cot',
  'uc.show.astc': 'ASTC ਦਿਖਾਓ',
  'uc.snap.common': 'ਸਾਧਾਰਨ ਕੋਣਾਂ ਤੇ ਸਨੈਪ',
  'uc.angle.value': '∠',
  'uc.units.deg': 'ਡਿਗਰੀ',
  'uc.units.rad': 'ਰੇਡ',
  'uc.units.both': 'ਡਿਗਰੀ+ਰੇਡ',
  'ws.fn': 'ਫੰਕਸ਼ਨ',
  'ws.fn.sin': 'sin',
  'ws.fn.cos': 'cos',
  'ws.fn.tan': 'tan',
  'ws.fn.csc': 'csc',
  'ws.fn.sec': 'sec',
  'ws.fn.cot': 'cot',
  'ws.amplitude': 'A — ਆਯਾਮ',
  'ws.frequency': 'B — ਫ੍ਰੀਕਵੈਂਸੀ',
  'ws.phase': 'C — ਫੇਜ਼ ਸ਼ਿਫਟ',
  'ws.shift': 'D — ਉਪਰ-ਥੱਲੇ ਸ਼ਿਫਟ',
  'ws.rform.toggle': 'R-ਫਾਰਮ',
  'ws.rform.a': 'a (sin ਗੁਣਾਂਕ)',
  'ws.rform.b': 'b (cos ਗੁਣਾਂਕ)',
  'ws.rform.r': 'R',
  'ws.rform.alpha': 'α',
  'ws.reset': 'ਰੀਸੈੱਟ',
  'ws.base': 'ਮੂਲ ਵਕਰ',
  'ip.id.pythagorean': 'ਪਾਇਥਾਗੋਰਸ',
  'ip.id.reciprocal': 'ਉਲਟ',
  'ip.id.quotient': 'ਭਾਗਫਲ',
  'ip.id.sum': 'ਜੋੜ',
  'ip.id.difference': 'ਅੰਤਰ',
  'ip.id.double': 'ਦੁੱਗਣਾ',
  'ip.id.half': 'ਅੱਧਾ',
  'ip.play': 'ਚਲਾਓ',
  'ip.pause': 'ਰੋਕੋ',
  'ip.step': 'ਕਦਮ',
  'ip.reset': 'ਰੀਸੈੱਟ',
  'ip.proof.pythagorean.summary': 'sin²θ + cos²θ = 1',
  'ip.proof.reciprocal.summary': 'csc θ = 1/sin θ,  sec θ = 1/cos θ,  cot θ = 1/tan θ',
  'ip.proof.quotient.summary': 'tan θ = sin θ / cos θ',
  'ip.proof.sum.summary': 'sin(A+B) = sin A cos B + cos A sin B',
  'ip.proof.difference.summary': 'sin(A−B) = sin A cos B − cos A sin B',
  'ip.proof.double.summary': 'sin 2θ = 2 sin θ cos θ',
  'ip.proof.half.summary': 'sin(θ/2) = ±√((1 − cos θ)/2)',
  'ip.proof.v2.note': 'v2 ਵਿੱਚ — ਇਸ ਸਾਬਤੀ ਲਈ ਵਧੇਰੇ ਵਿਸਤ੍ਰਿਤ ਨਿਰਮਾਣ ਲੋੜੀਂਦਾ ਹੈ।',
  'ts.area': 'ਖੇਤਰਫਲ',
  'ts.sineRule': 'ਸਾਈਨ ਨਿਯਮ',
  'ts.cosineRule': 'ਕੋਸਾਈਨ ਨਿਯਮ',
  'ts.ambiguous.toggle': 'ਅਸਪੱਸ਼ਟ ਵੇਲੇ ਭੂਤ ਤ੍ਰਿਕੋਣ',
  'ts.reset': 'ਸਮਪਾਸੇ ਉੱਤੇ ਰੀਸੈੱਟ',
  'ts.snap.integers': 'ਪੂਰਨ ਅੰਕਾਂ ਤੇ ਸਨੈਪ',
  'ts.side.a': 'a',
  'ts.side.b': 'b',
  'ts.side.c': 'c',
  'ts.angle.A': 'A',
  'ts.angle.B': 'B',
  'ts.angle.C': 'C',
  'ts.section.sides': 'ਪਾਸੇ',
  'ts.section.angles': 'ਕੋਣ',
  'ts.section.sineRule': 'ਸਾਈਨ ਨਿਯਮ',
  'ts.section.cosineRule': 'ਕੋਸਾਈਨ ਨਿਯਮ',
  'ts.section.area': 'ਖੇਤਰਫਲ',
  'cp.omega': 'ਕੋਣੀ ਵੇਗ',
  'cp.plot.y': 'y ਖਿੱਚੋ (sin)',
  'cp.plot.x': 'x ਖਿੱਚੋ (cos)',
  'cp.polar.label': 'ਧਰੁਵ ਚਿੱਤਰ',
  'cp.polar.circle': 'ਚੱਕਰ (r = 1)',
  'cp.polar.rose': 'ਗੁਲਾਬ (r = sin 3θ)',
  'cp.polar.cardioid': 'ਦਿਲ-ਆਕਾਰ (r = 1 + cos θ)',
  'cp.polar.limacon': 'ਲਿਮਾਸਨ (r = 1 − 2 cos θ)',
  'cp.smallAngle': 'ਛੋਟਾ ਕੋਣ ਅਨੁਮਾਨ (sin x ≈ x)',
  'cp.play': 'ਚਲਾਓ',
  'cp.pause': 'ਰੋਕੋ',
  'cp.reset': 'ਰੀਸੈੱਟ',
  'cp.step': 'ਕਦਮ π/12',
};
